'use strcit'

// const async = require('async')

function NOOP () {}

// export function load_images (src, callback = NOOP) {
//   src = util.isArray(src)
//     ? src
//     : [src]

//   const tasks = src.map((src) => {
//     return (done) => {
//       load_one_image(src, done)
//     }
//   })

//   async.parallel(tasks, callback)
// }


export function load_image (src, callback) {
  const image = new Image()
  let doned

  function done (err) {
    if (doned) {
      return
    }
    doned = true
    image.onload = image.onerror = image.onabort = null

    if (err) {
      return callback(err)
    }

    const {
      height,
      width,
      src
    } = image

    callback(null, {
      height,
      width,
      src
    })
  }

  image.onload = () => {
    done()
  }

  image.onabort = () => {
    done('abort')
  }

  image.onerror = () => {
    done('error')
  }


  image.src = src
}



// WEBPACK FOOTER //
// ./static/lazyload/lib/load.js